import * as Sentry from '@sentry/react';
import { useLocalStorage } from '@marqvision/shared';

export const usePmmLocalStorage = <T>() => {
  const [pmmStorage, setPmmStorage] = useLocalStorage<string>('product-marketing-material-data', JSON.stringify({}));

  let parsedData: T | null = null;
  const handleSetPmmData = (newData: (prevData: T) => T) => {
    const data = typeof newData === 'function' ? newData(parsedData as T) : newData;
    setPmmStorage(JSON.stringify(data));
  };
  try {
    parsedData = JSON.parse(pmmStorage) as T;
  } catch (error) {
    Sentry.captureException('FAILED TO PARSE Product Marketing Material Data', {
      extra: {
        pmmStorage,
      },
    });
  }
  return { parsedData, handleSetPmmData };
};
